var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterByArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "ml-2 mt-1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.62194 11.7616C8.25409 12.0918 7.69027 12.079 7.33765 11.7231L2.27436 6.61365C1.90855 6.24451 1.90855 5.646 2.27436 5.27686C2.64016 4.90771 3.23325 4.90771 3.59906 5.27686L8 9.71795L12.4009 5.27686C12.7667 4.90771 13.3598 4.90771 13.7256 5.27686C14.0915 5.646 14.0915 6.24451 13.7256 6.61365L8.66235 11.7231C8.64897 11.7367 8.63551 11.7495 8.62194 11.7616Z",
    fill: "#151515",
    className: "hc-icons"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterByArrow);
export default __webpack_public_path__ + "static/media/filter-by-arrow.8c0714613f6f80c5f0a286a2fa2fb9c8.svg";
export { ForwardRef as ReactComponent };